import { CreateSaleVariables } from './useCreateWarehouseSale';
import {
  OperationKeyHandle,
  OperationKeyStore,
  operationKeyScope,
  useOperationKey,
} from './useOperationKey';

/** What a Sale series pins with its first attempt: the Sale every retry resends (R2-4). */
export interface PinnedSaleRequest {
  payload: CreateSaleVariables;
}

/** The key of the series' pinned Sale, if one is pinned; never creates one. */
export function pinnedSaleKey(
  operationKeys: OperationKeyStore,
): string | undefined {
  return operationKeys.peek<PinnedSaleRequest>()?.payload.dto.operationKey;
}

/** The series target of a Sale started outside a visit (Produkty). */
export const STANDALONE_SALE_TARGET = 'standalone';

/**
 * F-1 (Q-4): a Sale entry point's operation-key series, one per organization
 * and visit (`standalone` without one). It lives in Phase 1's registry, so an
 * unresolved Sale outlives the form and its host (a Produkty tab switch, a
 * closed visit) and is forgotten on logout. The entry point passes it to
 * `WarehouseSaleFormModal` as `operationKeys`.
 */
export function useSaleOperationKey(
  organizationId: string | undefined,
  visitId?: string,
): OperationKeyHandle {
  return useOperationKey(
    operationKeyScope(
      'sale',
      organizationId,
      visitId ?? STANDALONE_SALE_TARGET,
    ),
  );
}
